const ellipsis={
    bind(el,{value}){
        var useValue;
        var val=el.innerHTML;
        var valLength=el.innerHTML.length;
        if(value>0){
            if(valLength>value){
                useValue=val.substring(0,value+1)+"...";
            }else {
                useValue=val
            }
        }else {
            useValue=val
        }
        el.innerHTML=useValue
    },
    update(el,{value}){
        var useValue;
        var val=el.innerHTML;
        var valLength=el.innerHTML.length;
        if(value>0){
            if(valLength>value){
                useValue=val.substring(0,value+1)+"...";
            }else {
                useValue=val
            }
        }else {
            useValue=val
        }
        el.innerHTML=useValue
    },
};

export default ellipsis
